import React from 'react'
import Event from './event'
import EmptyDay from '../day/empty'

const DayEventRows = ({ events, position }) => {
  return events.length ? (
    events.map((event, i) => (
      <Event
        event={event}
        position={position}
        key={i}
      />
    ))
  ) : (
    <EmptyDay />
  )
}

export default DayEventRows
